// use rafc snippet
function Line(){
  return (
    <div className="h-[42px] w-[1px] border-dotted border-2 border-[#AFB2BF] relative left-6">
    </div>
  )
}
export default Line;

